export default __webpack_public_path__ + "/dist/images/3034080.2cc35aad31dfe6a4407fdae8a07473de.png";